import { isNil, pick, each, flow, identity, keys, keyBy } from 'lodash';
import { curriedIntersection, curriedPickBy, curriedMapValues } from '@core/lib/fp';

const urlSegments = ['id', 'appToken', 'trackerToken', 'secretId', 'partnerId', 'token', 'preset'];

const whitelistedProps = ['main_account_id', 'current_account_id', 'role'];

/**
 * @param {Object} transition
 * @param {Function} href
 */
const trackRouteChange = (transition, href) => {
  if (isNil(window.newrelic)) {
    return;
  }

  const stateName = transition.$to().name;
  const stateParams = transition.params();
  const params = _getSegmentedParams(stateParams);
  const [interactionName] = href(stateName, {
    ...stateParams,
    ...params,
  })
    .replace('#', '')
    .split('?');

  newrelic.interaction().setName(interactionName);
};

/**
 * @param {Object} userData
 */
const setUserContext = userData => {
  if (isNil(window.newrelic)) {
    return;
  }

  const userLimitedProps = pick(userData, whitelistedProps);

  each(userLimitedProps, (value, key) => {
    newrelic.setCustomAttribute(key, value);
  });
};

/**
 * @param {Object} params
 * @returns {Object}
 * @private
 */
const _getSegmentedParams = params =>
  flow(
    curriedPickBy(identity),
    keys,
    curriedIntersection(urlSegments),
    keyBy,
    curriedMapValues(() => '*')
  )(params);

const self = {
  trackRouteChange,
  setUserContext,
  _getSegmentedParams,
};

export default self;
